import React from 'react';
import TopMenu from '@src/business-components/top-menu';
import MapStore from './store';
import useStore from '@src/utils/hooks/use-store';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
import Page from '@src/components/page';
import cx from 'classnames';
import Link from '@src/components/link';
import CommonFooter from '@src/business-components/common-footer';
import BaseSwiper from '@src/components/swiper/base-swiper';

const Map = () => {
  const store = useStore(() => {
    return new MapStore();
  });
  const handleSlideClick = e => {

    const target = e.target;
    if (target.className.includes('more')) {
      const item = store.meachaData[target.getAttribute('data-btn')];
      store.gounit(item.mecha_id);
    }
  };
  const mechaSwiper = () => {
    if (store.meachaData?.length > 0) {
      return (
        <div className={(styles.mechaSwiper, 'mechaSwiper')} onClick={handleSlideClick}>
          <BaseSwiper store={store.mechaSwiper}>
            {store.meachaData?.map((item, index) => {
              return (
                <div className={cx(styles.mechaItem, 'mechaItem')} key={index}>
                  <div className={styles.mecha} style={{
                    backgroundImage: `url(${item.mecha_img})`
                  }} />

                  <div className={cx('driver', 'driver' + (index + 1))} style={{
                    backgroundImage: `url(${item.driver_img})`
                  }} />
                  <div className={cx(styles.pilot, 'pilot' + (index + 1))} style={{
                    backgroundImage: `url(${item.driverName})`
                  }} />
                  <div className={styles.hud} />
                  <div className={styles.btn_more} style={{
                    backgroundImage: `url(${item.btn_more})`
                  }} data-btn={index} />
                  <div className={styles.enName} />
                  <div className={styles.ref} style={{
                    backgroundImage: `url(${item.ref})`
                  }} />
                  <div className={styles.name}>
                    {item.name}
                  </div>
                </div>
              );
            })}
          </BaseSwiper>
          <Link className={styles.prevBtn} onClick={store.versionTabSwiper.goPrev} />
          <Link className={styles.nextBtn} onClick={store.versionTabSwiper.goNext} />
          <div className={styles.tabSwiper}>
            <BaseSwiper store={store.versionTabSwiper}>
              {store.meachaData?.map((item, index) => {
                return (
                  <div className={cx('tabItem')} key={index}>
                    <div
                      className={cx('tabImgs', 'tabImg1')}
                      style={{
                        backgroundImage: `url(${item.mecha_tab_icon_act})`
                      }}
                    />
                    <div
                      className={cx('tabImgs', 'tabImg2')}
                      style={{
                        backgroundImage: `url(${item.mecha_tab_icon})`
                      }}
                    />
                  </div>
                );
              })}
            </BaseSwiper>
          </div>
          <Link onClick={() => store.toList()} className={styles.footer}>
            <div className={styles.count}>
              <span style={{ color: '#02eff8' }}>
                {(store.mechaSwiper.activeIndex + 1).toString().length === 1
                  ? '0' + (store.mechaSwiper.activeIndex + 1)
                  : store.mechaSwiper.activeIndex + 1}
              </span>/0{store.meachaData?.length}
            </div>
          </Link>
        </div>
      );
    }
  };
  return (
    <Page className={styles.root}>
      <TopMenu />
      {mechaSwiper()}
      {/* 底栏 */}
      <div className={styles.footerBox}>
        <CommonFooter />
      </div>
    </Page>
  );
};

export default wrapStore(Map, MapStore);
